<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-2" flat>
        <v-layout row wrap>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Fatura Listesi</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field flat="" solo-inverted="" hide-details v-model="search3"  :label="this.$t('Search')" append-icon="search"></v-text-field>
            <a target="_self" v-bind:href="'#/faturalar/serbestfatura/yeni'">
              <v-btn flat> <span class="hidden-sm-and-down"> Serbest Fatura Ekle </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </a>
          </v-toolbar>
          <v-container fluid="">
            <v-layout row wrap="">
              <v-flex xs12 sm4 md2>
                <v-menu :close-on-content-click="true" v-model="menu" transition="scale-transition" offset-y full-width
                  :nudge-right="40" min-width="290px">
                  <v-text-field slot="activator" :label="$t('Starting-Date')" v-model="dateFormatted" append-icon="event"
                    v-on:change="onChange" mask="##.##.####" @blur="date = parseDate(dateFormatted)" data-vv-name="tarihsecbas"
                    :error-messages="errors.collect('tarihsecbas')" v-validate="'required'" required></v-text-field>
                  <v-date-picker locale="tr" v-model="date" @input="dateFormatted = formatDate($event)" no-title
                    scrollable actions>
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-menu :close-on-content-click="true" v-model="menu2" transition="scale-transition" offset-y
                  full-width :nudge-right="40" min-width="290px">
                  <v-text-field slot="activator" :label="$t('Finishing-Date')" v-model="dateFormatted2" append-icon="event"
                    v-on:change="onChange2" mask="##.##.####" @blur="date2 = parseDate2(dateFormatted2) " data-vv-name="tarihsecbit"
                    :error-messages="errors.collect('tarihsecbit')" v-validate="'required'" required></v-text-field>
                  <v-date-picker locale="tr" id="datem2" v-model="date2" @input="dateFormatted2 = formatDate2($event)"
                    no-title scrollable actions>
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex>
                <v-layout>
                  <div v-if="load1">
                    <v-btn color="info" @click="getList()" fab small="" dark>
                      <v-icon>search</v-icon>
                    </v-btn>
                  </div>
                  <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                    color="info" fab dark>
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-tooltip bottom="" :activator="el" v-model="tooltip">
                    <span>{{$t('Add-Search-Filter')}}</span>
                  </v-tooltip>
                </v-layout>

              </v-flex>
            </v-layout>
          </v-container>

          <v-layout row="" wrap="">



            <v-flex xs12 sm12 md12>
              <v-card>
                <v-card-title>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                  :search="search3">
                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                  <template slot="items" slot-scope="props">
                    <tr item>

                      <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                      <td class="text-xs-left">{{ props.item.Faturano }}</td>
                      <td class="text-xs-left">{{ props.item.FaturaTarih}}</td>
                      <td class="text-xs-left">{{ props.item.Tip}}</td>
                      <td class="text-xs-left">{{ props.item.FaturaVade}}</td>
                      <td class="text-xs-left">{{ props.item.Kalan}}</td>
                      <td class="text-xs-left">{{ props.item.Tutar }}</td>
                      <td class="text-xs-left">{{ props.item.Kdv }}</td>
                      <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                      <!-- <v-btn icon class="mx-0" @click="kayitcek(props.item)">
                        <v-icon color="red">line_weight</v-icon>
                      </v-btn> -->
                      <v-btn icon class="mx-0" @click="efaturagoster(props.item)">
                        <v-icon color="teal">line_weight</v-icon>
                      </v-btn>
                      <v-btn icon class="mx-0" @click="git(props.item.FaturaTarih,props.item.Cari.Kod,props.item.Tip,props.item.FaturaSeri,props.item.Faturano)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search3 }}" found no results.
                  </v-alert>
                </v-data-table>
              </v-card>



              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
              </v-snackbar>
            </v-flex>
          </v-layout>


          <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="600px">

            <v-card color="grey lighten-2">

              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <div class="flex md12">
                    <v-layout>
                      <v-text-field hide-details="" style="padding-right:5px;" v-model="SerbestFatura.BaslangicFaturaNo"
                        :label="$t('Invoice-No') + '-1'" required> </v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFatura.BitisFaturaNo" :label="$t('Invoice-No') + '-2'" required>
                      </v-text-field>

                    </v-layout>
                  </div>

                  <div class="flex md12">
                     <cariaracomp v-bind:etiket="$t('Accound-Code')" :loading="loading" v-bind:value="SerbestFatura.Cari.Kod" v-model="SerbestFatura.Cari.Kod"></cariaracomp>
                  </div>

                  <div class="flex md12">
                    <v-layout>
                      <parainput style="padding-right:3px;" v-model="SerbestFatura.MinTutar" :etiket="$t('Min-Amount')"
                        :autocomplete="autocomplete"></parainput>

                      <parainput :name="maxtutar" v-model="SerbestFatura.MaxTutar" :etiket="$t('Max-Amount')" :autocomplete="autocomplete"></parainput>
                    </v-layout>
                  </div>

                  <div class="flex md12">


                    <div class="card__text grey darken-1 white--text">
                      <h3>{{$t('Options')}}</h3>
                    </div>

                    <v-radio-group hide-details="" v-model="SerbestFatura.FaturaTp" :label="$t('Invoice-Type')" column>
                      <v-radio :label="$t('All')" value="H"> </v-radio>
                      <v-radio :label="$t('Free')" value="S"></v-radio>
                      <v-radio :label="$t('Ticket')" value="B"></v-radio>
                      <v-radio label="Coper" value="c"></v-radio>
                    </v-radio-group>

                    <v-checkbox :label="$t('Use-Due-Date')" hide-details="" v-model="SerbestFatura.VadeTarihi"></v-checkbox>
                    <v-checkbox :label="$t('Show-Only-Invoices-Balance')" hide-details="" v-model="SerbestFatura.Bakiyeli"></v-checkbox>
                    <v-checkbox :label="$t('Show-Free-Invoices-Registered-Current')" hide-details=""
                      v-model="SerbestFatura.CariyeKaydedilmeyen"></v-checkbox>
                    <v-checkbox :label="$t('All-Companies')" hide-details="" v-model="tumsirketler"></v-checkbox>
                  </div>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{$t('Apply-Filters')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>




    <v-dialog v-model="faturadialog" scrollable="" max-width="850px">
      <v-card>
        <v-card-title> {{ $t('E-Invoice') }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">

            <div class="flex md12">
              <span id="demo2">
              </span>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>


  </div>


</template>


<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'


  export default {
    data() {
      return {
        headers: [{
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri',
            width: '10'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
            width: '10'
          },
          {
            text: this.$t('Invoice-Date'),
            value: 'FaturaTarih'
          },
          {
            text: this.$t('Invoice-Type'),
            value: 'Tip'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'FaturaVade'
          },
          {
            text: this.$t('Remaining'),
            value: 'Kalan'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar'
          },
          {
            text: this.$t('VAT'),
            value: 'Kdv'
          },
          {
            text: this.$t('Current'),
            value: 'Cari.Kod'
          }

        ],




        indir: [{
            text: 'Html ' + this.$t('Download')
          },
          {
            text: 'Excel ' + this.$t('Download')
          }
        ],

        itemslist: [{
            icon: 'folder',
            iconClass: 'grey lighten-1 white--text',
            title: 'Photos',
            subtitle: 'Jan 9, 2014'
          },
          {
            icon: 'folder',
            iconClass: 'grey lighten-1 white--text',
            title: 'Recipes',
            subtitle: 'Jan 17, 2014'
          },
          {
            icon: 'folder',
            iconClass: 'grey lighten-1 white--text',
            title: 'Work',
            subtitle: 'Jan 28, 2014'
          }
        ],
        items2: [{
            icon: 'assignment',
            iconClass: 'blue white--text',
            title: 'Vacation itinerary',
            subtitle: 'Jan 20, 2014'
          },
          {
            icon: 'call_to_action',
            iconClass: 'amber white--text',
            title: 'Kitchen remodel',
            subtitle: 'Jan 10, 2014'
          }
        ],


        tooltip: false,
        el: null,
        SerbestFatura: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          BaslangicFaturaNo: null,
          BitisFaturaNo: null,
          Cari: {
            Kod: null
          },
          MinTutar: 0,
          MaxTutar: 0,
          VadeTarihi: false,
          Bakiyeli: false,
          CariyeKaydedilmeyen: false,
          FaturaTp: 'H'
        },
        faturadialog: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        date2yedek: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        search3: '',
        renk: 'white',
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        e6: [],
        tumsirketler: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        search: '',
        search1: '',
        cariKod: '',
        progress: false,


        dictionary: {
          custom: {

            tarihsecbas: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsecbit: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },

        maxtutar: 'maxtutar',
        autocomplete: 'autocomplete',
        etiket: 'Max Tutar',

        mintutar: 'mintutar',
        etiketmin: 'Min Tutar',

        filtre: {
          a: '',
          b: '',
          c: ''
        },
        dialogfiltre: false,
        tooltip: false,
        el: null,

      }
    },
    beforeMount: beforeMount,
    mounted() {
      this.el = this.$refs.fab.$el
    },
    components: {
      'parainput': parainput,
      cariaracomp
    },
    watch: {
    },
    methods: {
      formatDate(date) {

        var str = date
        var n = str.search('.')
        if (n == 1) {} else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      formatDate2(date) {

        var str = date
        var n = str.search('.')
        if (n == 1) {

          return null
        } else {

          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {

        } else if (n == -1 && m != 8) {

          this.date = getDateNow()
          this.dateFormatted = getDateNow1()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      parseDate2(date) {

        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {

          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {

        } else if (n == -1 && m != 8) {

          this.date2 = getDateNow()
          this.date2yedek = this.date2
          this.dateFormatted2 = getDateNow1()

        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      onChange: onChange,
      onChange2: onChange2,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      git: git,
      kayitcek: kayitcek,
      efaturagoster: efaturagoster,
    },
  }


  function git(fattarih1, carikod1, evraktip1, faturaseri1, faturano1) {

    if (evraktip1 == "SER") {
      evraktip1 = "SF"
      var url = '#/faturalar/serbestfatura/id?' + 'ft=' + fattarih1 + '&ck=' + carikod1 + '&et=' + evraktip1 + '&es=' +
        faturaseri1 + '&en=' + faturano1 + '&ner=' + "X" + '&sb=' + true + '&islem=get'
      window.open(url, '_target')
    } else {
      this.text1 = this.$t('Please-Choose-a-Free-Invoice')
      this.snackbar = true
    }
  }

  function getList() {

    this.$validator.validateAll().then((result) => {

      if (result) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {



          var credentials = JSON.parse(window.localStorage.getItem('credentials'));


          this.progress = true
          this.load1 = false

          if (this.tumsirketler === true) {
            this.SerbestFatura.SirketKodu = '0'
          } else {
            this.SerbestFatura.SirketKodu = credentials.SirketKodu
          }


          this.SerbestFatura.BaslangicTarih = this.date
          this.SerbestFatura.BitisTarih = this.date2

          var params = this.SerbestFatura

          this.$http.post(auth.API_URL + 'api/Report/InvoiceReport', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body.FaturaBilgi

            this.progress = false
            this.load1 = true

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true

            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true

            }
          })
        } else {
          this.text1 = this.$t('start-date-cannot-greater-than-end-date')
          this.snackbar = true
        }
      }
    })
  }



  function kayitcek(v) {

    var params = {
      id: v.EFaturaShowID.EFaturaID,
      guid: v.EFaturaShowID.EFaturaGuid
    }

    this.$http.post(auth.API_URL + 'api/EFatura/GetFatura', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.faturadialog = true
      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }


  function getListHtml() {
    this.load = true
    this.load1 = false
    var params = {
      StartDate: this.date,
      EndDate: this.date2
    }
    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrentHtmlReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "Mizan.html";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true
      }
    })
  }


  function getListExcel() {
    this.load = true
    this.load1 = false
    var params = {
      StartDate: this.date,
      EndDate: this.date2
    }
    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrentExcelReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/xlsx'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "Mizan.xlsx";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      }
    })
  }




  function efaturagoster(v) {

    var params = {
      id: v.EFaturaShowID.EFaturaID,
      guid: v.EFaturaShowID.EFaturaGuid
    }

   var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$http.post(auth.API_URL + 'api/EFatura/FaturaShow', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
      }
    }).then((response) => {
      this.faturadialog = true
      document.getElementById("demo2").innerHTML = response.body;
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }


  function beforeMount() {
    this.load1 = true
    this.dateFormatted = getDateNow1()
    this.date = getDateNow()
    this.dateFormatted2 = getDateNow1()
    this.date2 = getDateNow()

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.progress = true
    this.load1 = false
    this.SerbestFatura.SirketKodu = credentials.SirketKodu
    this.SerbestFatura.BaslangicTarih = this.date
    this.SerbestFatura.BitisTarih = this.date2

    var params = this.SerbestFatura

    this.$http.post(auth.API_URL + 'api/Report/InvoiceReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body.FaturaBilgi

      this.progress = false
      this.load1 = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      }
    })

  }

  function filtrele() {
    this.dialogfiltre = true
  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false
    this.SerbestFatura.BaslangicFaturaNo = null
    this.SerbestFatura.BitisFaturaNo = null
    this.SerbestFatura.Cari.Kod = null
    this.SerbestFatura.MinTutar = 0
    this.SerbestFatura.MaxTutar = 0
    this.SerbestFatura.FaturaTp = null
    this.SerbestFatura.VadeTarihi = false
    this.SerbestFatura.Bakiyeli = false
    this.SerbestFatura.CariyeKaydedilmeyen = false
    this.tumsirketler = false
  }


  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)

      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesin
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date = b
          this.dateFormatted = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil

        } else {
          this.date = b
        }
      } else {
        this.dateFormatted = null
      }
    } else {
      this.dateFormatted = null

    }
  }

  function onChange2(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)
      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesi
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date2 = b
          this.dateFormatted2 = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date2 = b
          this.dateFormatted2 = '30' + '-' + ay + '-' + yil

        } else {
          this.date2 = b
        }
      } else {
        this.dateFormatted2 = null
      }
    } else {
      this.dateFormatted2 = null
    }
  }

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }
</script>

<style>

</style>